








import Header from '@/components/common/Header.vue';
import InfoBar from '@/components/common/InfoBar.vue';
import PrivateNetworksTable from '@/components/network/private-network/PrivateNetworksTable.vue';

export default {
  name: 'PrivateNetworksList',
  components: {
    Header,
    InfoBar,
    PrivateNetworksTable,
  },
};
